export default __webpack_public_path__ + "static/media/google.c1d1cef5.png";